import React from 'react';

import { Bone } from '@lightspeed/flame/Bone';

interface SkeletonCellProps {
  isLoading: boolean;
  height?: number | `${number}%` | `${number}px` | `${number}`;
  children: React.ReactNode;
}

const LoadingSkeletonCell: React.FC<SkeletonCellProps> = ({ isLoading, children, height }) => {
  return <>{isLoading ? <Bone height={height} data-test="loadingBone" /> : children}</>;
};

export default LoadingSkeletonCell;
